import classNames from "classnames";
import React from "react";

export function NavbarBase(props: {
	children: React.ReactNode;
	is_fixed?: boolean;
	customLogoUrl?: string | null;
	customLogoServerId?: string | null;
}) {
	const logoSrc = props.customLogoUrl || "/static/logo2transparent.png";
	const isCustomLogo = Boolean(props.customLogoUrl);
	const logoHref = isCustomLogo && props.customLogoServerId
		? `/dashboard/${props.customLogoServerId}`
		: "/";

	return (
		<>
			<nav
				className={classNames({
					"topnav--static": !props.is_fixed,
					topnav: props.is_fixed,
				})}
			>
				<div className="columns is-vcentered is-centered is-mobile">
					<div className="column is-11">
						<div className="columns is-vcentered is-mobile">
							<div className="column is-narrow">
								<a href={logoHref}>
									<img
										src={logoSrc}
										alt={isCustomLogo ? "Server Logo" : "Sesh Logo"}
										className={classNames("header-logo", {
											"rounded-full": isCustomLogo,
										})}
										style={isCustomLogo ? { objectFit: "cover" } : undefined}
									/>
								</a>
							</div>
							{props.children}
						</div>
					</div>
				</div>
			</nav>
			<div className="p-6"></div>
		</>
	);
}
